import { AfterViewInit, Component, EventEmitter, HostListener, inject, Input, OnChanges, OnInit, Output, QueryList, SimpleChanges, TemplateRef, ViewChildren, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ValidatorFn, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatMenuTrigger } from '@angular/material/menu';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { BENEFITS_KEY, PricePlanService } from 'src/app/components/Price-subscritions/priceplanService';
import { BusinessProvider } from 'src/app/guard/business-details-guard.ts.service';
import { ApiService } from 'src/app/services/api.service';
import { FormValidation } from 'src/app/services/FormValidation';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { UtilService } from 'src/app/services/util.service';
import Swal, { SweetAlertOptions } from 'sweetalert2';
import { ContactDetailsComponent } from '../contact-details/contact-details.component';
import { NetworkDetailsComponent } from '../customer-network/network-details/network-details.component';
import { CustomerService, TEXT_FIELDS } from '../customer-service.service';
import { CustomerUserDetailsComponent } from '../customer-user-details/customer-user-details.component';
import { WorkspaceDetailsComponent } from '../customer-workspace/workspace-details/workspace-details.component';
import { ManageNetworksComponent } from '../manage-networks/manage-networks.component';
import { JobService } from 'src/app/services/job.service';
import { AppSettings } from 'src/app/services/AppSettings';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { RouterModule } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { NgSelectModule } from '@ng-select/ng-select';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';



interface CustomModalOptions extends ModalOptions {
  title: any,
  planDetails: any,
}

@Component({
  selector: 'app-manage-template',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, InfiniteScrollModule, RouterModule,
MatMenuModule, NgSelectModule,
    NG_ICON_DIRECTIVES,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './manage-template.component.html',
  styleUrls: ['./manage-template.component.scss']
})
export class ManageTemplateComponent extends FormValidation implements OnInit, OnChanges , AfterViewInit{


  validationForm = {};
  @Output() updateParent = new EventEmitter();
  @Output() updateMembers = new EventEmitter();
  @Output() searchEmit = new EventEmitter();
  @Input() cancelplanUserId!: EventEmitter<any>;
  @Input() title: string;
  @Input() showCrown: boolean = false;
  @Input() ownerView: boolean = false;
  @Input() KEY: BENEFITS_KEY;
  @Input() parentData: any;
  @Input() userData: Array<any>;
  @Input('FIELDS') labelFields: Array<Partial<TEXT_FIELDS>>;
  @Input('COLUMNFIELDS') Fields: Array<Partial<TEXT_FIELDS>>;
  @Input('onSearch') startSearch: Function;
  @Input('onFilter') startFilter: Function;
  @Input('onScroll') startScroll: Function;
  @Input('holder') placeHolderData = "Search by name (or) email";
  @Input() dropdownContext: any = [
    {
      label: 'Status',
      payload: 'status',
      options: [
        { value: 'ACTIVE', label: 'Active' },
        { value: 'INACTIVE', label: 'Inactive' },
      ],
    }
  ];
  @Input('this') superObj: NetworkDetailsComponent | WorkspaceDetailsComponent | ContactDetailsComponent
 | CustomerUserDetailsComponent | ManageNetworksComponent;
  @Input() content: string;
  url = AppSettings.photoUrl;
  searchSubject = new Subject();
  scrollSubject = new Subject();
  router = inject(Router);
  parentActive: boolean = false;
  disabled: boolean = true;
  swalWithBootstrapButtons = Swal.mixin({
    customClass: { confirmButton: 'btn btn-success', cancelButton: 'btn btn-danger' },
    buttonsStyling: false
  });
  ref: any;
  membershipType: any;
  tempUserData: any;
  filterData: any = {};
  breadCrumbsArr: any = [];
  businessData: any;
  role:any;
  tempName: any;

  constructor(private customerService: CustomerService, private JobServicecolor: JobService,
    private pricePlanService: PricePlanService, private businessProvider: BusinessProvider,
    private API: ApiService, private aRoute: ActivatedRoute, private utilService: UtilService,
    private modalService: BsModalService
  ) {
    super()
    const business = this.businessProvider.getBusiness();
    if(business){
      this.businessData = business;
      this.role= business.role;
    }

    this.breadCrumbsArr = this.aRoute.snapshot.data.breadCrumbs as Array<any>;
  }

  ngAfterViewInit(): void {
    console.log("After view init");

  }

  getNetworksTitle(networks: string[]): string {
    if (networks?.length > 0) {
      return networks.join('\n');  // Join networks with a new line for each
    }
    return 'N/A';
  }
  onDropdownChange(payload: string): void {

    const currentSelection = this.filterData[payload];
      if (!currentSelection || currentSelection.length === 0) {
          this.saveFilter();
      }
  }
  tooltipModify(val: any, object: any) {
    if (val === undefined || val === null) {
      return '';
    }
    const data = object.options.find(option => option.value === val);
    return data ? data.label : '';
  }
  getParams(row) {
    let data: any = { ...this.businessData };


    if (this.KEY === "B2B_NETWORKS") {
      data.contactBusinessId = row.businessId;
    }
    else if (this.KEY === "B2B_CONTACTS") {
      data.contactBusinessId = row.businessId;
    }
    else if (this.KEY === "MANAGE_NETWORKS") {
      data.networkId = row.businessNetworkId;
    } else if (this.KEY === "MANAGE_BUSINESS_NETWORK") {
      data.businessNetworkId = row.b2bNetworkId;
    }

    return data;
  }

  getBreadCrumbs(arg: string[]): any[] {
    return []
  }

  @ViewChildren(MatMenuTrigger) trigger: QueryList<MatMenuTrigger>;
  @HostListener('window:scroll', [])
  scrollHandler() {
    for(let index = 0; index < this.trigger.toArray().length; index++) {
      this.trigger.toArray()[index].closeMenu();
    }
  }

  // onMenuOpened() {
  //   document.body.style.overflow = 'hidden';
  // }

  // onMenuClosed() {
  //   document.body.style.overflow = '';
  // }

  toTitleCase(str) {
    return str.replace(
      /\w\S*/g,
      text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    const user = (changes.userData && changes.userData.currentValue) != null ? changes.userData.currentValue : null;
    const parent = (changes.parentData && changes.parentData.currentValue != null) ? changes.parentData.currentValue : null;
    if (user != undefined && user.length != 0) {

      user.forEach(ele => {
        ele.enabled = this.getStatusBoolean(ele);
        if (ele.userType) {
          ele.userType = ele.userType && ele.userType.replaceAll("_", " ");
          ele.userType = (ele.userType === GigsumoConstants.MTA || ele.userType === GigsumoConstants.MANAGEMENT_TALENT_ACQUISITION || ele.userType === GigsumoConstants.MTA_TITLECASE)  ? GigsumoConstants.MANAGER : ele.userType;
          ele.userType = this.toTitleCase(ele.userType);
        }
        if (this.title === 'Manage Members') {
          if (ele.organisation == 'null' || ele.organisation == null || ele.organisation == '' ||
            ele.organisation == undefined) {
            ele.organisation = 'NA'
          }
          if (ele.contactType == 'null' || ele.contactType == null || ele.contactType == '' ||
            ele.contactType == undefined) {
            ele.contactType = 'NA'
          }
        }
      });
      this.userData = user;

      if (this.title === 'Manage Members') {
        const filteredData = this.userData.filter(ele => (ele.connectionStatus === 'CONNECTED' || ele.connectionStatus === 'INACTIVE'));
        this.userData = filteredData;
      }
      this.tempUserData = structuredClone(this.userData);
    }

    if (parent != undefined) {

      this.parentData = parent;
      this.parentActive = this.getParentStatusBoolean();

      if (this.labelFields) {
        this.labelFields.forEach((e: any) => {
          if (e.validate) {
            const key = e.key;
            this.validationForm = {
              ...this.validationForm,
            };
            this.validationForm[`${key}`] = new FormControl(`${this.parentData[e.key]}`);
            (this.validationForm[`${key}`] as FormControl).setValidators(this.getValidationArr(e));
            this.validationForm[`${key}`].updateValueAndValidity();
          }
        });
      }


    }

  }

  getValidationArr(d): ValidatorFn[] {
    let arr: ValidatorFn[] = [];

    if (d.required) {
      arr.push(Validators.required);
    }

    if (d.min) {
      arr.push(Validators.minLength(d.min));
    }

    if (d.max) {
      arr.push(Validators.maxLength(d.max));
    }

    if (d.pattern) {
      arr.push(Validators.pattern(d.pattern));
    }


    return arr;
  }

  ngOnInit(): void {
    this.search();
    this.scroll();
     
  }




  getParentStatusBoolean(): boolean {
    return this.isParentConnectedField() ?
      (this.parentData[this.getParentkey()] === 'CONNECTED' ? true : false) :
      (this.parentData[this.getParentkey()] === 'ACTIVE' ? true : false)
  }

  getContent(d) {
    return [d.label];
  }

  getStatusBoolean(ele): boolean {
    return this.isConnectedField() ?
      ((this.KEY === "B2B_CONTACTS" && this.content != "MANAGE_BUSINESS_CONTACTS") ? (ele[this.getKey()] === 'ACTIVE' ? true : false) :
        (ele[this.getKey()] === 'CONNECTED' ? true : false)) :
      (ele[this.getKey()] === 'ACTIVE' ? true : false)
  }

  isParentConnectedField(): boolean {
    return this.KEY === "B2B_CONTACTS";
  }

  getParentkey(): string {
    return this.KEY === "B2B_CONTACTS" ? 'connectionStatus' : 'status'
  }

  isConnectedField(): boolean {
    return this.KEY === "INCLUDED_CONVERSATIONS" || this.KEY === "B2B_CONTACTS"
      || this.KEY === "MANAGE_BUSINESS_CONTACT";
  } 

  isConenctionStatus() {

  }

  scroll() {
    this.scrollSubject.pipe(
      debounceTime(500)
    ).subscribe(data => {
      this.startScroll(this.superObj);
    });
  }

  search() {
    this.searchSubject.pipe(
      debounceTime(1000),
      distinctUntilChanged()
    ).subscribe(response => {
      if (response != null) {
        this.startSearch(response, this.superObj);
      }

    });
  }

  getKey() {
    if (this.content === "MANAGE_BUSINESS_CONTACTS") return "connectionStatus";
  
    switch (this.KEY) {
      case "TEAM_WORKSPACES":
      case "B2B_NETWORKS":
        return "connectionStatus";
  
      case "USERS":
        return "planAccessStatus";
  
      case "B2B_CONTACTS":
        return "userStatus";
  
      case "MANAGE_WORKSPACES":
      case "MANAGE_BUSINESS_NETWORK":
      case "MANAGE_NETWORKS":
        return "status";
  
      default:
        return "connectionStatus";
    }
  }
  


  getWorkspaceParams(row) {
    return { ...this.businessData, teamId: row.teamId };
  }

  // goback() {
  //   this.router.navigateByUrl(this.customerService.getPreviousUrl());
  // }
  
  goback() {
    const previousUrl = this.customerService.getPreviousUrl();
    if (previousUrl) {
      this.router.navigateByUrl(previousUrl);
    }
  }

    isProcessing: boolean = false;
    async onStatusChange(checked: boolean) {
    if (this.isProcessing) {
      console.log("Action already in progress. Skipping this click.");
      return;
    }
     this.isProcessing = true;
     console.log(this.parentActive )
      if (!checked) {
        this.swalWithBootstrapButtons.fire({
          icon: "warning",
          showConfirmButton: true,
          showCancelButton: true,
          reverseButtons: true,
          allowOutsideClick: false,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          ...this.getDeactivatedMessage(),
        }).then(event => {
          console.log(event);
          if (event.isConfirmed) {
            this.updateStatus();
          }
           this.parentActive = event.isConfirmed ? false : true;
           this.isProcessing = false;
        });

      } else if (checked) {
        let plan: any;
        if (this.KEY === 'TEAM_WORKSPACES') {
          plan = await this.getUserPLanBenefits(this.parentData.teamsOwnerId);
        } else {
          plan = await this.getBusinessPLanBenefits();
        }

        if (plan.available > 0 ) {
          this.updateStatus();
        } else {
          plan.membershipType = this.membershipType;
          this.planvalidationpopup(plan, this.title);
          this.parentActive = false;
        }
         this.isProcessing = false;
      }

  }  

  planvalidationpopup(plan, selecteditem) {
    this.utilService.startLoader();
    let benefitkey = this.KEY
    this.pricePlanService.expiredPopup(
      benefitkey,
      "PAY",
      null,
      null,
      null,
      null,
      plan.available,
      plan.actual,
      plan.utilized,
      plan.promotional
    );

    this.utilService.stopLoader();
  }

  onStatusChangeOfMember(checked: boolean, index: number) {
    if (this.KEY != 'USERS') {    
       this.userData[index][this.getKey()] = this.userData[index].enabled ?
        (this.isConnectedField() ? "CONNECTED" : "ACTIVE") : "INACTIVE"; 
    }  

    if (this.userData[index].userType) {
      this.userData[index].userType = this.userData[index].userType.replaceAll(' ', "_");
    }

    if(this.userData[index].userType === GigsumoConstants.MANAGER) {
      this.userData[index].userType = GigsumoConstants.MANAGEMENT_TALENT_ACQUISITION
    } 
    this.updateMembers.emit({ value: this.userData[index], checked: checked });
 
  }

  

  isSuperAdmin(index: number): boolean {

    if (this.KEY === "USERS" || this.KEY === "TEAM_WORKSPACES") {
      return this.userData[index]?.isSuperAdmin ?? false;
    }
    if (this.userData[index]?.b2bNetworkName === "General Network") {
      return true;
    }
    return false;
  }

  updateMembersData() {

  }

  async getBusinessPLanBenefits() {
    this.isProcessing=false
    const userPlan: any = await this.API.lamdaFunctionsget('findBusinessPlanBenefits/' + this.businessData.id);
    const plan = userPlan.data.businessPlanAndBenefits.benefitsUsages;
    this.membershipType = userPlan.data.businessPlanAndBenefits.membershipType;
    if (plan) {
      return plan.find(x => x.benefitKey === this.KEY);
    }
  }

  async getUserPLanBenefits(userId: string) {
    this.isProcessing=false
    const userPlan: any = await this.API.lamdaFunctionsget('findUserPlanBenefits/' + userId);
    const plan = userPlan.data.userPlanAndBenefits.benefitsUsages;
    this.membershipType = userPlan.data.userPlanAndBenefits.membershipType;
    if (plan) {
      return plan.find(x => x.benefitKey === this.KEY);
    }
  }

  getDeactivatedMessage(): SweetAlertOptions<any, any> {
    switch (this.KEY) {
      case "TEAM_WORKSPACES":
        return {
          title: 'Inactive Workspace',
          text: "Are you sure you want to move Workspace to inactive state?"
        };
      case "PERSONAL_NETWORKS":
        return {
          title: 'Inactive Network',
          text: "Are you sure you want to move Network to inactive state?"
        };
      case "B2B_NETWORKS":
        return {
          title: 'Inactive Business Network',
          text: "Are you sure you want to move Business Network to inactive state?"
        };
      case "B2B_CONTACTS":
        return {
          title: 'Inactive Business',
          text: "Are you sure you want to move Business to inactive state?"
        };
      default:
        break;
    }
  }



  onFocus(key) {

    if (key === 'members') {
      return;
    }
    this.tempName = this.parentData[key];
    this.disabled = false;
  }

  focusOut(data) {
    if (data.key === 'members') {
      return;
    }

    console.log("asas" , this.tempName , this.parentData[data.key]);

    if(this.tempName != this.parentData[data.key]){
      if (!data.validate || (data.validate && this.validationForm[data.key].valid)) {
        this.disabled = true;
        this.updateStatus();
      }
    }


  }
  isCheckboxDisabled(): boolean {
    const connectionStatus = this.parentData?.connectionStatus;
    const isDefault = this.parentData?.isDefault;
    const networkName = this.parentData?.b2bNetworkName;

    return !(connectionStatus === 'CONNECTED' || connectionStatus === 'INACTIVE' || connectionStatus == null)
      || (isDefault && networkName === 'General Network');
  }

  getInputClass(item: any): string {
    if (item?.disabled || this.parentData?.b2bNetworkName === 'General Network') {
      return 'disable';
    }
    return 'frayed';
  }

  updateStatus() {
    this.isProcessing=false;
    if(this.isParentConnectedField()){
        this.parentData[this.getParentkey()] = this.parentActive ? "CONNECTED" : "INACTIVE";
    } else{
      this.parentData['beforeStatus']=this.parentData['status'];
      this.parentData['status'] = this.parentActive ? "ACTIVE" : "INACTIVE";
    }
    console.log(this.parentData);

     this.updateParent.emit(this.parentData);
  }

  saveFilter() {
    this.startFilter(this.filterData, this.superObj);
  }

  onScrollDown() {
    console.log("SCrolled distance " , this.superObj.stopScroll);

    if (!this.superObj.stopScroll) {
      this.scrollSubject.next("");
    }
  }


  enableStatusToggle(item) {
    return this.KEY === "INCLUDED_CONVERSATIONS" ? item.connectionStatus != "REQUEST_SENT" :
      this.KEY === "USERS" ? item.userStatus != 'BLOCKED' :
      true;
  }

  getStatusText(item) {
    return this.KEY === "INCLUDED_CONVERSATIONS" ?
      (item.connectionStatus === "REQUEST_SENT" ? "Pending" : item.connectionStatus) :
      this.KEY === "USERS" ? item.userStatus : item.status;
  }


  showCrownSvg(field, userdata) {
    const index = this.Fields.indexOf(field);
    return ((this.KEY === "USERS" || this.KEY === "TEAM_WORKSPACES" ||
      (this.KEY === "B2B_CONTACTS" && this.content != "MANAGE_BUSINESS_CONTACTS"))
      && index === 0 && userdata.isSuperAdmin) ? true
      : false
  }

  getMultiple(d) {
    return d.label === 'Network' ? true : false;
  }

  // Filter helper methods for checkbox-based filtering
  isFilterSelected(payload: string, value: string): boolean {
    const filterValue = this.filterData[payload];
    if (Array.isArray(filterValue)) {
      return filterValue.includes(value);
    }
    return filterValue === value;
  }

  toggleFilter(payload: string, value: string, event: Event, isMultiple: boolean): void {
    const isChecked = (event.target as HTMLInputElement).checked;

    if (isMultiple) {
      // Multi-select: manage as array
      if (!this.filterData[payload]) {
        this.filterData[payload] = [];
      }
      if (isChecked) {
        if (!this.filterData[payload].includes(value)) {
          this.filterData[payload] = [...this.filterData[payload], value];
        }
      } else {
        this.filterData[payload] = this.filterData[payload].filter(v => v !== value);
        if (this.filterData[payload].length === 0) {
          delete this.filterData[payload];
        }
      }
    } else {
      // Single-select: only one value at a time
      if (isChecked) {
        this.filterData[payload] = value;
      } else {
        delete this.filterData[payload];
      }
    }
  }

  hasActiveFilters(): boolean {
    return Object.keys(this.filterData).some(key => {
      const val = this.filterData[key];
      return val !== undefined && val !== null && (Array.isArray(val) ? val.length > 0 : true);
    });
  }

  getActiveFilterCount(): number {
    let count = 0;
    Object.keys(this.filterData).forEach(key => {
      const val = this.filterData[key];
      if (val !== undefined && val !== null) {
        if (Array.isArray(val)) {
          count += val.length;
        } else {
          count += 1;
        }
      }
    });
    return count;
  }

  clearAllFilters(): void {
    this.filterData = {};
    this.startFilter(this.filterData, this.superObj);
  }


  disableField(item) {
    return (item.key === 'members' || item.key === 'owner' ||
      item.key === 'membersCount')
  }


  // Allocate to diff user


    filterbyRole(user, type) {
      const roleMap = {
        jobs: [GigsumoConstants.RECRUITER, GigsumoConstants.FREELANCE_RECRUITER, GigsumoConstants.MANAGEMENT_TALENT_ACQUISITION],
        candidates: [GigsumoConstants.BENCH_RECRUITER, GigsumoConstants.FREELANCE_RECRUITER, GigsumoConstants.MANAGEMENT_TALENT_ACQUISITION]
      };
      return user.filter(item => roleMap[type]?.includes(item.userType));
    }

    modalRef: any;
    selectedUser: string;
    closeModal() {
      this.modalRef.hide();
      this.selectedUser = "";
    }

     openModel(template: TemplateRef<any>) {
      this.modalRef = this.modalService.show(template, {
        animated: true,
        backdrop: "static",
      });
    }

    TransferUser(){

    }

    selectUser(item: any) {
      console.log(item)

    }

    // User Letter Update profile
    getInitialstwo(firstname: string, lastname: string): string {
      return this.JobServicecolor.getInitialsparam(firstname, lastname);
    }

    getColortwo(firstname: string, lastname: string): string {
      return this.JobServicecolor.getColorparam(firstname, lastname);
    }



}
